/* eslint-disable */
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {GAME_CONVENTIONS, ROOM_TABLE_TITLES, TABLE_INDICATOR_COLORS} from "../../../constants/index.jsx";
import {useTranslation} from "react-i18next";
import combinedButtons from "../Buttons/RoomButtons/index.jsx";
import TableHeader from "../../../core/Table/TableHeader/TableHeader.jsx";
import SafeDynamicComponent from "../SafeDynamicComponent.jsx";

function RoomList() {
    const {isMobile, currency} = useSelector((state) => state.user);
    const userId = useSelector((state) => state.user.id);
    const {t} = useTranslation()
    const roomList = useSelector((state) => state.cash.roomList);
    const filter = useSelector((state) => state.cash.filter);
    let filteredRoomList = [...roomList];
    const [rows, setRows] = useState([])
    const flattedConventions = GAME_CONVENTIONS.flat()
    const applyFilters = () => {
        for (const key in filter) {
            if (filter[key] && key === "minBet") {
                filteredRoomList = filteredRoomList.filter(item => {
                    return (+item.rows.table_room_bet[currency]) >= filter.minBet
                })
            }
            if (filter[key] && key === "maxBet") {
                filteredRoomList = filteredRoomList.filter(item => {
                    return (+item.rows.table_room_bet[currency]) <= filter.maxBet
                })
            }
            if (filter[key]?.length && key === "score") {
                const values = filter.score.map(({value}) => value);
                filteredRoomList = filteredRoomList.filter(item =>
                    values?.includes(item.rows.table_room_till)
                );
            }
            if (filter[key]?.length && key === "time") {
                const values = filter.time.map(({value}) => value);
                filteredRoomList = filteredRoomList.filter(item =>
                    values?.includes(item.rows.table_room_stepTime)
                );
            }
            if (filter[key]?.length && key === "status") {
                const values = filter.status.map(({value}) => value);
                filteredRoomList = filteredRoomList.filter(item =>
                    values?.includes(item.rows.table_room_status)
                );
            }
            if (filter[key]?.length && key === "type") {
                const values = filter.type.map(({value}) => value);
                filteredRoomList = filteredRoomList.filter(item =>
                    values.some((val) => item.rows.table_room_type.indexOf(val) !== -1)
                );
            }
        }

        const updatedRows = filteredRoomList.map(item => {
            return {
                row: item.rows,
                showData: item?.showData
            }
        });
        setRows(updatedRows)
    }

    useEffect(() => {
        applyFilters()
    }, [filter, roomList]);

    const getTitle = (value) => {
        return flattedConventions.find(item => item.value === value)?.label
    }

    const mobileButtonColor = (status, isBonus, player) => {
        if (isBonus && status === "WAITING" && player !== userId) return "gold"
        return TABLE_INDICATOR_COLORS[status]
    }

    const renderRow = (cells, index) => {
        const RoomRowButton = combinedButtons[cells["table_room_status"]];

        const playerCellValue =  cells['table_room_player'];
        const player2CellValue = cells['table_room_player2'];
        return <div key={index + 'desktop'} className={`table-body--row hover`}>
            <div
                className={`table-body--cell table-body--cell--${TABLE_INDICATOR_COLORS[cells["table_room_status"]]}`}>{cells['table_room_id']}</div>
            <div className="table-body--cell">{playerCellValue}</div>
            <div className="table-body--cell">{cells['table_room_score']}</div>
            <div className="table-body--cell">{player2CellValue}</div>
            <div className="table-body--cell">{(cells['table_room_bet']?.[currency])?.toFixed(2)}
                <span className="currency-small">{currency}</span>
            </div>
            <div className="table-body--cell">{cells['table_room_till']}</div>
            <div className="table-body--cell">{cells['table_room_stepTime']}{t('table.s')}</div>
            <div className="table-body--cell">
                <div className="table-body--cell--icons">
                    {
                        cells['table_room_type']?.map((item, index) => {
                            return <i
                                key={`icon-${item}${index}`}
                                className={`icon-${item} table-icon`}
                                title={t(`form.${getTitle(item)}`)}
                            />
                        })
                    }
                </div>
            </div>
            <div className="table-body--cell table-body--cell--buttons">
                <SafeDynamicComponent Component={RoomRowButton} row={cells}/>
            </div>
        </div>
    }
    const renderRowMobile = (cells, key) => {
        const RoomRowButton = combinedButtons[cells["table_room_status"]]
        return <div key={key + 'mobile'}
                    className={`mobile-created-game-row ${TABLE_INDICATOR_COLORS[cells["table_room_status"]]}`}>
            <div className="mobile-created-game-left">
                <div className="mobile-created-game-left__top">
                    <span className="text">ID: {cells["table_room_id"]}</span>
                    <span className="text">{(cells["table_room_bet"]?.[currency])?.toFixed(2)}<span
                        className="currency-small">{currency}</span></span>
                </div>
                <div className="mobile-created-game-left__bottom">
                    <span
                        className="text">{t('table.table_room_till')}: {cells['table_room_till']} | {t('table.table_room_step_time')}: {cells['table_room_stepTime']} {t('table.s')}</span>
                    <div className="mobile-created-game-left__bottom--conventions">
                        {
                            cells['table_room_type']?.map((item, index) => {
                                return <i key={index} className={`icon-${item}`}/>
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={`mobile-created-game-right ${mobileButtonColor(cells["table_room_status"], cells["table_room_is_bonus"], cells["table_room_player"])}`}>
                <SafeDynamicComponent Component={RoomRowButton} row={cells}/>
            </div>
        </div>
    }
    return <>
        {
            !isMobile
                ?
                <div className="table-wrapper">
                    <div className="table">
                        <TableHeader columns={ROOM_TABLE_TITLES}/>
                        <div className="table-body">
                            {
                                rows?.map((row, index) => {
                                    return renderRow(row?.row, index)
                                })
                            }
                        </div>
                    </div>
                </div>
                :
                <div className="mobile-created-games">
                    {
                        rows?.map((row, index) => {
                            return renderRowMobile(row?.row, index)
                        })
                    }
                </div>
        }
    </>
}

export default RoomList